export const formatNumber = (number) => {
  return number > 0 ? number.toLocaleString() : ''
};
